import { ApiHelper } from './apiHelper';

export class TitleApi {
    async getTitlesAsync(
        token: string,
        successCallback: (titles: string[]) => void,
        failureCallback: (error: string) => void,
        signal: AbortSignal
    ): Promise<void> {
        const dataUrl = '/api/title/title';

        await new ApiHelper().getDataSecureAsync(
            dataUrl,
            token,
            successCallback,
            failureCallback,
            signal
        );
    }
}
